import { createSlice, type PayloadAction } from '@reduxjs/toolkit';


const TOKEN_KEY = 'jwt';
const REFRESH_KEY = 'jwt_refresh';

function readKey(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  sessionExpired: boolean;
}

const initialState: AuthState = {
  token: readKey(TOKEN_KEY),
  refreshToken: readKey(REFRESH_KEY),
  sessionExpired: false
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    sessionEstablished(
      state,
      action: PayloadAction<{ token: string; refreshToken?: string }>
    ) {
      state.token = action.payload.token;
      state.sessionExpired = false;
      try {
        localStorage.setItem(TOKEN_KEY, action.payload.token);
        if (action.payload.refreshToken) {
          state.refreshToken = action.payload.refreshToken;
          localStorage.setItem(REFRESH_KEY, action.payload.refreshToken);
        }
      } catch {
      }
    },
    sessionExpired(state) {
      state.sessionExpired = true;
      state.token = null;
      state.refreshToken = null;
      try {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_KEY);
      } catch {
      }
    },
    signedOut(state) {
      state.token = null;
      state.refreshToken = null;
      state.sessionExpired = false;
      try {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_KEY);
      } catch {
      }
    }
  }
});

export const { sessionEstablished, sessionExpired, signedOut } = authSlice.actions;
export const authReducer = authSlice.reducer;
